import { useMemo } from "react";
import { useHasPermission } from "../../../../../components/permission";
import { TableHeaders } from "../../../../../components/table/Head";
import { countries } from "../../../../../store/common/models";
import { VerificationDTO } from "../../../../../store/verification/models/dto/kyc";

interface KycRow {
  firstName: VerificationDTO.Responses.GetSingleKyc.T["user"]["firstName"];
  lastName: VerificationDTO.Responses.GetSingleKyc.T["user"]["lastName"];
  country: typeof countries.T | null;
  emailAddress: VerificationDTO.Responses.GetSingleKyc.T["user"]["emailAddress"];
  userStatus: VerificationDTO.Responses.GetSingleKyc.T["userStatus"];
  createdDate: VerificationDTO.Responses.GetSingleKyc.T["createdDate"];
  companyId: VerificationDTO.Responses.GetSingleKyc.T["companyId"];
  fraudCheckId: VerificationDTO.Responses.GetSingleKyc.T["fraudCheckId"];
  ongoingBackgroundChecks: VerificationDTO.Responses.GetSingleKyc.T["ongoingBackgroundChecks"];
}

export type FieldNames = keyof KycRow;

export const useHeaders: () => TableHeaders<FieldNames> = () => {
  const isAdmin = useHasPermission(["ROLE_ADMIN"]);

  const defaultHeaders = useMemo<TableHeaders<FieldNames>>(
    () => [
      {
        name: "firstName",
        title: "First Name",
      },
      {
        name: "lastName",
        title: "Last Name",
      },
      {
        name: "emailAddress",
        title: "Email Address",
        hiddenMobile: true,
      },
      {
        name: "userStatus",
        title: "User Status",
      },
      {
        name: "companyId",
        title: "Company ID",
      },
      {
        // Used as Kyc Report Icon
        name: "ongoingBackgroundChecks",
        title: "Kyc Report",
        hiddenMobile: true,
      },
      {
        name: "country",
        title: "Country",
        hiddenMobile: true,
      },
      {
        name: "createdDate",
        title: "Date created",
        hiddenMobile: true,
      },
      {
        name: "fraudCheckId",
        title: "",
        centered: true,
        hiddenMobile: true,
      },
    ],
    []
  );

  return useMemo<TableHeaders<FieldNames>>(
    () =>
      defaultHeaders.filter(
        (x) =>
          (x.name !== "companyId" && x.name !== "ongoingBackgroundChecks") ||
          isAdmin
      ),
    [isAdmin, defaultHeaders]
  );
};
